import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=1630697e&"
import script from "./userList.vue?vue&type=script&lang=js&"
export * from "./userList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports